import { UserDto } from '@act/shared/data-transfer-objects';

/**
 * Deduplicates team list payloads by user id (first row wins), matching entity-adapter upsert behavior.
 *
 * @param users Users that may repeat when care-staff, system, and provider queries are merged.
 * @returns One entry per id.
 */
export function dedupeUserDtosById(users: UserDto[]): UserDto[] {
  const byId = new Map<string, UserDto>();
  for (const user of users) {
    if (!byId.has(user.id)) {
      byId.set(user.id, user);
    }
  }
  return [...byId.values()];
}
